

























import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Thdata from "../../../store/entities/thdata";
import Echarts from "../threcord/Echarts.vue";
import EchartsHumi from "../threcord/Echarts.vue";
import PageRequest from "@/store/entities/page-request";
class PageThRealTimeDataRequest extends PageRequest {
  AddTime: Date=new Date();
  snid: string;
  gastype:Number;
}
@Component({
  components: { Echarts,EchartsHumi },
})

export default class AnalyseThrealtimedata extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Date}) AddTime: Date;
   @Prop({ type: String}) snid: string;
   @Prop({type:String}) locationName:number;
    @Prop({type:Number}) gas_type:number;
     @Prop({type:Number}) g_max:number;
      @Prop({type:Number}) g_min:number;
  pagerequest: PageThRealTimeDataRequest = new PageThRealTimeDataRequest();
  componentKey: number = 10;
  componentKeyhumi:number=10;
  datalist = [];
  legenddata: string = "";
  xAxisdata: string = "";
  seriesdata: string = "";
  yAxisdata:string="";
  serieslist = [];
  yAxislist=[];
  thdata: Thdata = new Thdata();
  StartTime: string;
  EndTime: string;
  list=[];
  type="";
  strtitle:string="";

  async getPage() {
    //filters
    //debugger;
    //let ss=this.value;
    this.pagerequest.AddTime=this.AddTime;
    this.pagerequest.snid=this.snid;
    this.list=await this.$store.dispatch({
      type: "gasdata/getPagedLast",
      data: this.pagerequest,
    });
    //this.ThisThPaged();
   
    this.type="";
      if(this.gas_type==1){
            this.type="氧气";
        }else if(this.gas_type==2){
            this.type="二氧化碳";
        }else if(this.gas_type==2){
            this.type="氮气 ";
        }else if(this.gas_type==2){
            this.type="磷化氢";
        }else {
            this.type="一氧化碳";
        }
         this.strtitle=this.type+'浓度走势图';
    let titlelist = [this.type+"浓度检测"];

    this.serieslist.push(
      {
        name: this.type+"浓度",
        type: "line",
        data: [],
        markPoint: {
          data: []
          },
      }
    );
    let timelist = [];
    let datalist_temp1 = [];
    let point_temp1 = [];
    console.log(this.g_max);
    for (let entry of this.list) {
        timelist.push(this.GetMinutes(entry.addtime));
        if(entry.gas_type==1){
            if(entry.concentration > this.g_max || entry.temp < this.g_min){
          point_temp1.push({ value: entry.concentration,xAxis: this.GetMinutes(entry.addtime),yAxis:entry.concentration});
        }
        }else{
           if(entry.concentration > this.g_min){
          point_temp1.push({ value: entry.concentration,xAxis: this.GetMinutes(entry.addtime),yAxis:entry.concentration});
        }
        }
        datalist_temp1.push(entry.concentration);
      
      
    }
     console.log(point_temp1)

    this.serieslist[0].data = datalist_temp1;
    this.serieslist[0].markPoint.data = point_temp1;
    this.legenddata = JSON.stringify(titlelist);
    this.seriesdata = JSON.stringify(this.serieslist);
    this.xAxisdata = JSON.stringify(timelist);
    this.showEcharts();
  }
 GetMinutes(time) {
  //  console.log(time);
    let date = new Date(time);
    let Str = this.GetBqMinutes(date.getHours()) + ":" + this.GetBqMinutes(date.getMinutes());
    return Str;
  }
  GetBqMinutes(str){
    if(str.toString().length==1){
      return '0'+str;
    }
    return str;
  }
  visibleChange(value: boolean) {

    // this.ThisThPaged();

    if (!value) {
      this.$emit("input", value);
    } else {
      // this.thdata = Util.extend(
      //   true,
      //   {},
      //   this.$store.state.thdata.analyseThdata
      // );
      //console.log(this.$store.state.thdata.analyseThdata);
      this.getPage();
    }
    
  }

  cancel() {
    //this.getPage();
    this.$emit("input", false);
  }

  showEcharts() {
    this.componentKey += 1;
    this.componentKeyhumi+=1;
  }

  // async ThisThPaged(){
  //  this.list=await this.$store.dispatch({
  //     type:"thdata/getThisThPaged",
  //   });
  //   //return this.list;
    
  // }

 
}
